import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const VehiclesByBrandChart = ({ data }) => (
  <ResponsiveContainer width="100%" height={250}>
    <BarChart data={data}>
      <XAxis dataKey="marca" />
      <YAxis />
      <Tooltip />
      <Legend />
      <Bar dataKey="cantidad" fill="#2563EB" radius={[8, 8, 0, 0]} />
    </BarChart>
  </ResponsiveContainer>
);

export default VehiclesByBrandChart;